
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/settings/my-account/profile",
      function () {
        return require("private-next-pages/settings/my-account/profile.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/settings/my-account/profile"])
      });
    }
  